<template>
    <div class="container-fluid main">
        <header>
            <h1>
                BLUE
                <span class="slim-text">BAY</span>
                302
            </h1>
        </header>
        <div class="main__caption col-xl-12">
            <ul>
                <li>
                    <font-awesome-icon :icon="['fas', 'map']" />&nbsp;&nbsp; CABO SAN
                    LUCAS
                </li>
                <li>
                    <font-awesome-icon :icon="['fas', 'bed']" />&nbsp;&nbsp; SLEEPS 6
                </li>
                <li class="booking-scroll-link">
                    <a href="#booking">RESERVE NOW</a>
                    <font-awesome-icon :icon="['fas', 'chevron-right']" />
                </li>
            </ul>
        </div>
        <div class="image-with-text">
            <div class="image-with-text__text">
                <h3>CABO SAN LUCAS, MEXICO</h3>
                <p>
                    Located in the sought after address of the, "Pedregal" within Cabo San
                    Lucas and known as “The BEVERLY HILLS OF CABO SAN LUCAS.” it is
                    located a short few blocks away from restaurants , shops and
                    nightlife. The Pedregal community is a high end, exclusive
                    neighborhood with 24-hour security, which includes a guard at the
                    gated entrance plus 24-hour security patrol for added well-being.
                    Tennis & Pickle ball courts are provided by the Pedregal community as
                    well as private access to Pedregal’s exclusive Sunset Beach.
                </p>
            </div>
        </div>
        <div>
            <b-tabs align="center" content-class="mt-3" pills card>
                <div class="main__showcase-cards row">
                    <b-card :img-src="require('../assets/gallery/villas/blue_bay/web/302/blue_bay_living_302.jpeg')
                        " img-alt="Image" img-top class="col-xl-4">
                        <b-card-text>
                            This condo offers three bedrooms and three full baths with a gourmet
                            kitchen that has GRANITE COUNTER TOPS, stainless steel
                            appliances, refrigerator , gas stove, microwave, dishwasher,
                            Nespresso coffee maker, washing machine and clothes dryer. The
                            extra large master bedroom has its own private balcony with
                            fitness area.</b-card-text>
                    </b-card>
                    <b-card :img-src="require('../assets/gallery/villas/blue_bay/web/302/blue_bay_dining_302.jpeg')
                        " img-alt="Image" img-top class="col-xl-4">
                        <b-card-text>
                            The living area has a large screen TV that includes Pix
                            satellite service with complete viewing packages and adjoins a
                            large balcony with outdoor dining table. 2 of the 3 bedroom’s
                            also have large screen TV’s. Fiber-optic, high-speed internet is
                            throughout the unit. Luxery shampoo and conditioner, hairdryers
                            and all necessary items are in each bathroom. A private ,
                            covered parking space adjoins the unit and Housekeeping Services
                            are also included every other day.</b-card-text>
                    </b-card>
                    <b-card :img-src="require('../assets/gallery/villas/blue_bay/web/302/blue_bay_master_302.jpeg')
                        " img-alt="Image" img-top class="col-xl-4">
                        <b-card-text>This condo is recently remodeled with custom designed furniture
                            and enjoys elevated views of the Cabo San Lucas marina from the
                            living room and master bedroom. The complex also has a heated
                            infinity edge pool which has the same amazing views.
                        </b-card-text>
                    </b-card>
                </div>
                <b-carousel id="carousel-1" v-model="slide" controls indicators background="#ababab" img-width="1024"
                    img-height="280" style="text-shadow: 1px 1px 2px #333;" @sliding-start="onSlideStart"
                    @sliding-end="onSlideEnd" class="main-carousel">
                    <b-carousel-slide :img-src="require('../assets/gallery/villas/blue_bay/web/302/blue_bay_living_302.jpeg')
                        " />
                    <b-carousel-slide :img-src="require('../assets/gallery/villas/blue_bay/web/302/blue_bay_living_2_302.jpeg')
                        " />
                    <b-carousel-slide :img-src="require('../assets/gallery/villas/blue_bay/web/302/blue_bay_dining_302.jpeg')
                        " />
                    <b-carousel-slide :img-src="require('../assets/gallery/villas/blue_bay/web/302/blue_bay_master_302.jpeg')
                        " />
                    <b-carousel-slide :img-src="require('../assets/gallery/villas/blue_bay/web/302/blue_bay_spare_302.jpeg')
                        " />
                    <b-carousel-slide :img-src="require('../assets/gallery/villas/blue_bay/web/302/blue_bay_bath_302.jpeg')
                        " />
                    <b-carousel-slide :img-src="require('../assets/gallery/villas/blue_bay/web/302/blue_bay_balcony_302.jpeg')
                        " />
                    <b-carousel-slide :img-src="require('../assets/gallery/villas/blue_bay/web/301/blue_bay_courts.jpeg')
                        " />
                </b-carousel>
                <AmenetiesBlueBay302 />
            </b-tabs>
        </div>

        <div class="image-with-text">
            <div class="image-with-text__text">
                <p>
                    Optional transportation , concierge and breakfast services are also
                    available upon request. The Holiday weeks of Christmas and New Years
                    Eve each have 5 day minimum stays. For clarification please ask before
                    performing an "instant booking" or you may be required to cancel.
                    There is a 3 night minimum stay and a 6 person maximum occupancy.
                    Please clarify the make up of your group when making a reservation.
                    Excessive noise and unruly behavior will not be tolerated. Please feel free to ask about my other 3
                    Luxery vacation rental properties in the Pedregal community. Including the newly listed 2 bedroom 2 bath
                    adjoining unit which enables a 5 bedroom and 5 bathroom combination with this unit.
                </p>
            </div>
        </div>
        <h3 style="margin-top: 40px;" id="booking">CONTACT</h3>
        <p>
            This form does not officially reserve the location.
        </p>

        <SubContact />
        <Testimonials url="https://api.sitebot.com/api/vrbo/reviews.json?id=3164234" />
    </div>
</template>
  
<script>
import Testimonials from "../components/Testimonials";
import SubContact from "../components/SubContact";
import AmenetiesBlueBay302 from "../components/AmenetiesBlueBay302";
export default {
    data() {
        return {
            slide: 0,
            sliding: null,
        };
    },
    components: {
        Testimonials,
        SubContact,
        AmenetiesBlueBay302,
    },
    methods: {
        onSlideStart() {
            this.sliding = true;
        },
        onSlideEnd() {
            this.sliding = false;
        },
    },
};
</script>
  
<style lang="scss">
@import "../styles/main";

.main {
    font-family: "Raleway", sans-serif;

    &__showcase-cards {
        margin-top: 40px;
        margin-right: 0px;
        margin-left: 0px;
        margin-bottom: 40px;

        .card-text {
            font-family: "Raleway", sans-serif;
            line-height: 2rem;
        }

        .card {
            border: none;
        }
    }

    &__caption {
        padding-left: 0px !important;
        padding-right: 0px !important;

        ul {
            display: flex;
            list-style: none;
            justify-content: space-around;
            margin: auto;
            color: white;
            font-weight: 700;
            background-color: rgba(0, 0, 0, 0.8);
            width: 100%;
            margin-top: 20px;
            padding-left: 18%;
            padding-right: 20%;
            padding-top: 20px;
            padding-bottom: 20px;

            li:nth-child(3) {
                color: $text--blue--dark;
            }

            li {
                svg {
                    color: $text--blue--dark;
                }
            }

            @media only screen and (max-width: 800px) {
                padding-left: 1%;
                padding-right: 3%;
            }
        }

        .booking-scroll-link {
            position: relative;

            a {
                color: $text--blue--dark;

                &:hover {
                    color: $text--blue--dark;
                    text-decoration: none;
                }
            }

            .fa-chevron-right {
                position: absolute;
                top: 12%;
                left: 100%;
                margin-left: 5px;
                transition: all 0.3s ease-in-out;
            }

            &:hover {
                .fa-chevron-right {
                    left: 105%;
                }
            }
        }
    }

    .nav-link.active.tab-active-class {
        background-color: $text--blue--dark;
    }

    .main-carousel {
        width: 60vw;
        margin: auto;

        @media only screen and (max-width: 1200px) {
            width: 100%;
        }
    }

    .image-with-text {
        background-image: url("../assets/gallery/villas/villa_andaluza/web/Andaluza-41-min.jpg");
        background-color: rgba(100, 0, 0, 0.4);
        background-size: cover;
        background-repeat: none;
        background-position-y: center;
        line-height: 2rem;
        color: white;
        padding: 80px 0px 80px 0px;
        height: auto;

        &__text {
            background-color: rgba(0, 0, 0, 0.4);
            padding-top: 20px;
            padding-bottom: 20px;
        }

        h3 {
            font-weight: 800;
        }

        p {
            width: 70%;
            margin: auto;
            font-weight: 800;
            font-size: 20px;
            margin-top: 20px;
        }
    }
}

header {
    margin-top: 16px;
    display: flex;
    justify-content: center;

    h1 {
        font-size: 5rem;
        font-weight: 700;

        .slim-text {
            font-weight: 200;
        }
    }

    @media only screen and (max-width: 1000px) {
        h1 {
            font-size: 2rem;
        }
    }
}

h3 {
    font-size: 3rem;
}
</style>
  